
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineEndPoint as ObiGenericLineEndPointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-end-point.js';
 
 
 

 
 export const ObiGenericLineEndPoint = createComponent({
   react: React,
   tagName: 'obi-generic-line-end-point',
   elementClass: ObiGenericLineEndPointElement,
   events: {
     
   }
  });
 
 